/**
 * * @module pages/news.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import Video from "../components/video";

const NewsSingle = Backbone.View.extend({
  el: $(document),

  events: {
  },

  initialize: function () {
    this.render();
  },

  render: function () {
  },
});

export default NewsSingle;
